module.exports = __webpack_public_path__ + "toBride1-jp-w-b.f684630b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/toBride1-jp-w-b.jpg
// module id = thb+
// module chunks = 0